import React, { type ReactNode } from 'react';
import { ErrorBoundaryWithChunkErrorLogging } from '@atlassian/jira-onboarding-core/src/ui/error-boundary-with-chunk-error-logging/index.tsx';
import type { AnalyticsAttributes } from '@atlassian/jira-product-analytics-bridge';
import { PACKAGE_NAME } from '../../constants.tsx';

export const OnboardingNudgeErrorBoundary = (props: {
	id: string;
	attributes: AnalyticsAttributes;
	fallback: ReactNode;
	children: ReactNode;
}) => {
	const { id, attributes, fallback, children } = props;

	return (
		<ErrorBoundaryWithChunkErrorLogging
			id={id}
			packageName={PACKAGE_NAME}
			render={() => fallback}
			attributes={attributes}
		>
			{children}
		</ErrorBoundaryWithChunkErrorLogging>
	);
};
